import * as React from "react";

export interface IconProps extends React.SVGProps<SVGSVGElement> {
    size?: number | string;
    color?: string;
}

export const OrganizationIcon: React.FC<IconProps> = ({
    size = 20,
    color,
    ...props
}) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={props["aria-label"] ? undefined : true}
        {...props}
    >
        <path
            d="M10 2L3 6V18H8V12H12V18H17V6L10 2ZM10 4.21L15 7.21V16H14V10H8V16H5V7.21L10 4.21Z"
            fill={color || "currentColor"}
        />
    </svg>
);
